package diana.soleil.design.iraniancanadienbazzar.feature.addbusiness

import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

/** Koin bindings for the Add / Claim business wizard. Aggregated by the app composition root (`:shared`). */
val addBusinessModule = module {
    viewModel { AddBusinessViewModel(get(), get(), get(), get(), get(), get(), get()) }
}
